import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRtlLocale } from '@/i18n/config';

/**
 * Keeps the <html> `lang` and `dir` attributes synced with the active i18n locale.
 *
 * RTL-ready from day one — no Arabic/Hebrew at launch, but every layout
 * is engineered with logical CSS properties so adding an RTL locale is
 * a translation-file drop-in, not a UI refactor.
 */
export function useDirection(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    const dir = isRtlLocale(i18n.resolvedLanguage) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('lang', i18n.resolvedLanguage ?? 'en');
    document.documentElement.setAttribute('dir', dir);
  }, [i18n.resolvedLanguage]);
}
